<template>
  <div class="page">
    <div class="top">
      <van-icon name="play" size="20px" color="#555" />
      <img src="@/assets/ali.png" alt="">
      <i class="el-icon-caret-top" />
      <div> 请点击右上角选择在默认浏览器打开</div>
    </div>
    <div class="type">支付宝扫码支付</div>
    <div class="price">￥{{ price }}</div>
    <div class="countdown">支付剩余时间 <van-count-down :time="time" format="mm:ss" /></div>
    <div class="prompt">充值后，请返回主页面查询到账情况，避免多次付费。</div>
    <div class="priceCoe">
      <img :src="imgUrl" alt="">
    </div>
    <div class="hine">请截图二维码后，用支付宝扫一扫进行支付</div>
    <div class="f-button" style="width: 90%;margin: auto;">
      <van-button type="info" block round @click="sumbit">打开支付宝继续支付</van-button>
    </div>
    <div v-html="payUrls"></div>
    <div class="shareit" v-if="isShowImg">
      <img class="arrow" src="@/assets/img/arrowhead1.png" />
      <div class="follow">如已完成支付，退出重新登录查询即可</div>
    </div>


  </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast, Dialog } from 'vant';
export default {
  data() {
    return {
      payUrls: '',
      orderNo: '',
      price: '',
      isShowImg: false,
      imgUrl: '',
      time: 15 * 60 * 1000,
      payUrl: '',
      aliUrl: '',
    }
  },
  created() {
    this.isShowImg = false;
    if (this.$route.query.aliUrl) {
      this.imgUrl = this.$route.query.imgUrl;
      this.aliUrl = this.$route.query.aliUrl;
      window.location.href = "alipays://platformapi/startapp?saId=10000007&clientVersion=3.7.0.0718&qrcode=" + this.$route.query.aliUrl;
    } else {
      this.orderNo = this.$route.query.orderNo
      this.price = this.$route.query.price;
      wxRequest("sim/ali/ma/pay", { orderNo: this.orderNo }, "post").then((res) => {
        if (res.data.code == 200) {
          this.imgUrl = "http://vx.iot688.cn:8888/" + res.data.data.img;
          this.payUrl = res.data.data.url;
          var ua = window.navigator.userAgent.toLowerCase();
          if (ua.match(/MicroMessenger/i) != 'micromessenger') {
            window.location.href = this.payUrl;
          } else {
            this.$router.push({ path: '/user/aliMaPay', query: { aliUrl: this.payUrl, imgUrl: this.imgUrl } });
          }
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      })
    }

  },
  methods: {
    sumbit() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        //进入引导页
        this.isShowImg = true
        var timer = setInterval(() => {
          clearInterval(timer)
          this.$router.push({ path: '/user/aliMaPay', query: { aliUrl: this.payUrl, imgUrl: this.imgUrl } });
        }, 1000)
      } else {
        window.location.href = this.aliUrl;
      }
    }
  }
}
</script>
<style lang="less" scoped>
.page {
  background: #f5f5f5;
  height: calc(100vh - 20px);
  font-family: PingFangSC, PingFang SC;
  padding-top: 20px;

  .top {
    display: flex;
    width: 95%;
    margin: 0 auto 20px auto;
    background: #555;
    justify-content: center;
    align-items: center;
    color: #fff;
    border-radius: 6px;
    text-align: center;
    position: relative;
    padding: 5px 0;

    .van-icon-play {
      transform: rotate(-90deg);
      position: absolute;
      top: -12px;
      right: 20px;
    }

    img {
      width: 30px;
      height: 30px;
      margin-right: 14px;
    }
  }

  .type {
    height: 60px;
    text-align: center;
    font-size: 18px;
    color: #333;
    line-height: 60px;
    padding-left: 20px;
    background: #fff url('~@/assets/ali.png') no-repeat 25% center;
    background-size: 40px 40px;
  }

  .price {
    margin-top: 20px;
    /* background: #fff; */
    padding-top: 20px;
    padding-bottom: 30px;
    text-align: center;
    font-weight: bold;
    color: black;
    font-size: 44px;
    line-height: 30px;
  }

  .priceCoe {
    /* background: #fff; */
    text-align: center;
    margin-top: 15px;

    img {
      width: 300px;
      height: 300px;
    }
  }

  .hine,
  .f-button {
    /* background: #fff; */
    text-align: center;
    font-weight: bold;
    padding: 20px 0;
    color: #4b69ee;
  }

  .shareit {
    -webkit-user-select: none;
    position: fixed;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    text-align: center;
    top: 0;
    left: 0;
    z-index: 999;
  }

  .shareit img {
    max-width: 200%;
  }

  .arrow {
    /* width: 100px; */
    height: 150px;
    position: absolute;
    right: 5%;
    top: 1%;
  }

  .follow {
    margin-right: 6px;
    margin-left: 30px;
    width: 90%;
    // height: 100rpx;
    line-height: 30px;
    // text-align: left;
    text-decoration: none;
    font-size: 18px;
    color: white;
    float: left;
    margin-top: 180px;
  }

  .countdown {
    text-align: center;
    display: flex;
    /* background: #fff; */
    justify-content: center;
    align-items: center;
    color: #999999;
    padding-bottom: 20px;

    .van-count-down {
      color: #999999;
      padding-left: 6px;
    }
  }

  .prompt {
    font-size: 12px;
    background: #FFF3F3;
    width: 88%;
    margin: auto;
    border-radius: 8px;
    border: 1px solid #FFD4D5;
    text-align: center;
    height: 36px;
    line-height: 36px;
    color: #F0231D;
  }

}
</style>